import { render } from "./PagamentoSorteCartao.vue?vue&type=template&id=d339945e"
import script from "./PagamentoSorteCartao.vue?vue&type=script&lang=js"
export * from "./PagamentoSorteCartao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__